import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";

const LanguageGuides = () => {
  const { languageId } = useParams();
  const [guides, setGuides] = useState([]);
  const [languageName, setLanguageName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`http://localhost:1337/api/languages/${languageId}?populate=guides`)
      .then((response) => {
        const langData = response.data.data;

        if (langData) {
          setLanguageName(langData.name || "Language");
          setGuides(langData.guides || []);
        } else {
          setLanguageName("Language not found");
          setGuides([]);
        }
      })
      .catch((error) => console.error("Error fetching guides:", error));
  }, [languageId]);

  const handleGuideClick = (uid) => {
    navigate(`/guides/${uid}`, {
      state: {
        language: languageName,
      },
    });
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold text-white mb-6 border-b border-gray-600 pb-2">
        {languageName} Guides
      </h1>

      {guides.length > 0 ? (
        <div className="grid gap-4">
          {guides.map((guide) => (
            <div
              key={guide.id}
              className="bg-white text-black p-4 rounded-xl shadow-md hover:bg-blue-100 hover:shadow-lg transition cursor-pointer"
              onClick={() => handleGuideClick(guide.UID)}
            >
              <Link className="text-lg font-semibold">{guide.title || "Untitled Guide"}</Link>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-300">No guides found for this language.</p>
      )}
    </div>
  );
};

export default LanguageGuides;
